export default __webpack_public_path__ + "static/media/profile-icon.f8718206.jpg";